import React, { useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";
import { performancePages } from "../../../../constants";
import { toLocaleInteger } from "../../../../utils/utilityFunctions";
import SegmentVolumeSection from "./SegmentVolumeSection";
import SegmentTIVShareSection from "./SegmentTIVShareSection";

import { getBrandPerformanceSegmentVolume, getBrandPerformanceSegmentTIVShareVolume } from "../../../../api/brandPerformanceApi";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface Props extends RouteComponentProps {
  activePage: performancePages;
  diff: number;
  granularity: string;
}

const SegmentVolume = withRouter((props: Props) => {
  const { activePage, diff, history, granularity } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);
  const model = params.model;

  // fetch the trend and average data
  const {
    data: segmentVolumeData,
    isFetching: loadingSegmentVolumeData, // call data using react-query
    refetch: refetchSegmentVolumeData,
  } = useQuery(["segementVolumeData", granularity, history.location.search], () => getBrandPerformanceSegmentVolume(params), { enabled: false });

  const {
    data: segmentTIVShareVolumeData,
    isFetching: loadingSegmentTIVShareVolumeData, // call data using react-query
    refetch: refetchSegmentTIVShareVolumeData,
  } = useQuery(["segmentTIVShareVolumeData", granularity, history.location.search], () => getBrandPerformanceSegmentTIVShareVolume(params), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchSegmentVolumeData();
    refetchSegmentTIVShareVolumeData();
  }, [history.location.search]);

  return (
    <div className="segment_volume performance_page">
      <div className="data_area">
        <div className="volume_section">
          <SegmentVolumeSection
            chartData={segmentVolumeData}
            trendChartId="segment_volume_chart"
            trendTitle="Segment Volume"
            loadingTrend={loadingSegmentVolumeData}
            diff={diff}
            activePage={activePage}
            chartGranularity={granularity}
          />
        </div>
        <div className="tiv_section">
          <SegmentTIVShareSection
            chartData={segmentTIVShareVolumeData}
            trendChartId="segment_tiv_share_volume_chart"
            trendTitle="Segment TIV Share Volume"
            loadingTrend={loadingSegmentTIVShareVolumeData}
            diff={diff}
            activePage={activePage}
            percentageChart={true}
            chartGranularity={granularity}
          />
        </div>
      </div>
    </div>
  );
});

export default SegmentVolume;
